import React, { useState } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import styles from "./styles/sport-data.css.js";
import withStyles from "components/with-styles";
import Link from "components/link";
import FormConfirm from "components/form/form-confirm";
import { TextDisplay } from "components/display-data";
import Card from "@material-ui/core/Card";
import { PageHeaderBar } from "components/page";
import { AssetDisplay } from "components/thumbnail";
import { getScoreboardPreviewUrl } from "config/paths";
import { useAuthDataContext } from "components/auth";
import { SCOREBOARD_TYPE_NO_SCOREBOARD } from "../forms/common-forms/sport-form-constants";

const hasScoreboardSelected = event => event?.sportEventData?.scoreboardType !== SCOREBOARD_TYPE_NO_SCOREBOARD;

const WarningNoNames = ({ event }) => {
  const hasSportData =
    event &&
    event.sportEventData &&
    (event.sportEventData.teamName1Abreviated || event.sportEventData.teamName2Abreviated);

  return (
    !hasSportData && (
      <FormConfirm
        warning
        show
        hideCloseButton
        label={
          <>
            <FormattedMessage id="event.sportEventData.warning.noData" />
            &#160;
            <Link color="primary" href={`/event/edit/${event.id}/customer/${event.customerId}`}>
              <FormattedMessage id="common.edit" />
            </Link>
          </>
        }
      />
    )
  );
};

const EventData = ({ event, intl, classes }) => {
  const { token } = useAuthDataContext();
  const [showScoreboardPreview, setShowScoreboardPreview] = useState(true);
  return (
    <>
      <div className={classes.details}>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "event.scoreboardType" })}>
          <FormattedMessage id={`event.scoreboardType.in.${event.sportEventData.scoreboardType}`} />
        </TextDisplay>
        <TextDisplay className={classes.data} label={intl.formatMessage({ id: "event.scoreboardName" })}>
          {event.sportEventData.altScoreboardTemplateName}
        </TextDisplay>
      </div>

      {hasScoreboardSelected(event) && (
        <>
          <PageHeaderBar subtitle title="event.sportEventData.sportData.scoreboard.preview" />
          <div className={classes.scoreboardPreview_container}>
            {showScoreboardPreview && (
              <img
                className={classes.scoreboardPreview}
                onError={() => setShowScoreboardPreview(false)}
                src={getScoreboardPreviewUrl({ eventId: event.id, token })}
              />
            )}
          </div>
          <PageHeaderBar subtitle title="event.sportEventData.sportData" />
          <div>
            <DataGrid>
              <DataGridItem big>
                <WarningNoNames event={event} />
              </DataGridItem>
              <DataGridItem>
                <Card className={classes.dataCard}>
                  <DataGridItem className={classes.column} sizesOverride={{ xl: 6 }}>
                    <div className={classes.subtitle}>
                      <FormattedMessage id="event.sportEventData.team1" />
                    </div>
                    {event && event.sportEventData && (
                      <>
                        {event.sportEventData.teamLogoAsset1 ? (
                          <DataGridItem big>
                            <AssetDisplay asset={event.sportEventData.teamLogoAsset1} width={200} />
                          </DataGridItem>
                        ) : (
                          event.sportEventData.teamLogo1 && (
                            <DataGridItem big>
                              <img
                                className={classes.teamLogo}
                                src={event.sportEventData.teamLogo1}
                                alt={intl.formatMessage({ id: "event.sportEventData.teamLogo1" })}
                              />
                            </DataGridItem>
                          )
                        )}
                        <DataGridItem big>
                          <TextDisplay className={cn(classes.data, classes.teamName)}>
                            {event.sportEventData.teamName1Abreviated}
                          </TextDisplay>
                        </DataGridItem>
                        <DataGridItem big>
                          <TextDisplay className={classes.data}>{event.sportEventData.teamName1}</TextDisplay>
                        </DataGridItem>
                      </>
                    )}
                  </DataGridItem>
                </Card>
              </DataGridItem>
              <DataGridItem>
                <Card className={classes.dataCard}>
                  <DataGridItem className={classes.column} sizesOverride={{ xl: 6 }}>
                    <div className={classes.subtitle}>
                      <FormattedMessage id="event.sportEventData.team2" />
                    </div>
                    {event && event.sportEventData && (
                      <>
                        {event.sportEventData.teamLogoAsset2 ? (
                          <DataGridItem big>
                            <AssetDisplay asset={event.sportEventData.teamLogoAsset2} width={200} />
                          </DataGridItem>
                        ) : (
                          event.sportEventData.teamLogo2 && (
                            <DataGridItem big>
                              <img
                                className={classes.teamLogo}
                                src={event.sportEventData.teamLogo2}
                                alt={intl.formatMessage({ id: "event.sportEventData.teamLogo2" })}
                              />
                            </DataGridItem>
                          )
                        )}
                        <DataGridItem big>
                          <TextDisplay className={cn(classes.data, classes.teamName)}>
                            {event.sportEventData.teamName2Abreviated}
                          </TextDisplay>
                        </DataGridItem>
                        <DataGridItem big>
                          <TextDisplay className={classes.data}>{event.sportEventData.teamName2}</TextDisplay>
                        </DataGridItem>
                      </>
                    )}
                  </DataGridItem>
                </Card>
              </DataGridItem>
            </DataGrid>
          </div>
        </>
      )}
    </>
  );
};

EventData.propTypes = {
  /**
   * Data to represent
   **/
  event: PropTypes.object,
};

export default withStyles(styles)(injectIntl(EventData));
